import React from 'react';
import './radio.css';
import { cn } from 'helper/cn';

const RadioButton = ({
  title,
  onClick,
  selected,
  value,
  data,
  rootClassName,
  ...props
}) => {
  return (
    <div className={cn('round', rootClassName)}>
      <input
        type='checkbox'
        id={data?.id}
        name={data?.name}
        value={data?.id}
        checked={selected}
        onChange={(e) => onClick(e, data)}
      />
      <label htmlFor='checkbox' {...props}></label>
    </div>
  );
};

export default RadioButton;
